import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guestOnly: true }
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/regattas',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'regattas',
        name: 'Regattas',
        component: () => import('../views/Regattas.vue')
      },
      {
        path: 'results',
        name: 'Results',
        component: () => import('../views/Results.vue')
      },
      {
        path: 'lane-analysis',
        name: 'LaneAnalysis',
        component: () => import('../views/LaneAnalysis.vue')
      },
      {
        path: 'live',
        name: 'LiveRaces',
        component: () => import('../views/LiveRaces.vue')
      },
      {
        path: 'benchmark',
        name: 'BenchmarkAnalysis',
        component: () => import('../views/BenchmarkAnalysis.vue')
      },
      {
        path: 'athlete-results',
        name: 'AthleteResults',
        component: () => import('../views/AthleteResults.vue')
      },
      {
        path: 'splits',
        name: 'SplitsAnalysis',
        component: () => import('../views/SplitsAnalysis.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated

  if (to.meta.guestOnly && isAuthenticated) {
    return next('/regattas')
  }
  if (to.matched.some(r => r.meta.requiresAuth) && !isAuthenticated) {
    return next('/login')
  }
  next()
})

export default router
